import { render, staticRenderFns } from "./GeostatisticsCode.vue?vue&type=template&id=55565808&scoped=true&"
import script from "./GeostatisticsCode.vue?vue&type=script&lang=js&"
export * from "./GeostatisticsCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55565808",
  null
  
)

export default component.exports